/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import { KTIcon } from '../../../../../_metronic/helpers/index'
import ApexCharts, { ApexOptions } from 'apexcharts'

import { useDashboardStore } from '../../../../core/state-management/states/dashboard';
import { Mixed } from './Mixed';
import { useThemeMode } from '../../../../../_metronic/partials';
import { getCSSVariableValue } from '../../../../../_metronic/assets/ts/_utils';

type Props = {
    className: string;
    title?: string;
}

const ZemanatBox: React.FC<Props> = ({ className, title }) => {
    const { state } = useDashboardStore();
    const { dashboardValues } = state;
    const chartRef = useRef<HTMLDivElement | null>(null)
    const { mode } = useThemeMode()
    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const chart = new ApexCharts(chartRef.current, chartOptions('primary', '200px', dashboardValues?.zemanat.zemanatRatio as number))
        if (chart) {
            chart.render()
        }

        return chart
    }

    useEffect(() => {
        const chart = refreshChart()

        return () => {
            if (chart) {
                chart.destroy()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartRef, mode])
    return (
        <div className='card card-xl-stretch mb-5 mb-xl-8'>
            {/* begin::Header */}
            <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{title}  </h3>
                <div className='card-toolbar'>
                    {/* begin::Menu */}
                    <button
                        type='button'
                        className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                    >
                        <KTIcon iconName='category' className='fs-2' />
                    </button>
                    {/* end::Menu */}
                </div>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body pt-0'>
                {/* begin::Item */}
                <div className='flex-grow-1'>
                    <div ref={chartRef} className='mixed-widget-4-chart'></div>
                </div>
                {/* end::Item */}
                <div className='row g-0 mt-5 mb-10'>

                    {/* begin::Col */}
                    <div className='col'>
                        <div className='d-flex align-items-center me-2'>
                            {/* begin::Symbol */}
                            <div className='symbol symbol-50px me-3'>
                                <div className='symbol-label bg-light-info'>
                                    <KTIcon iconName='bucket' className='fs-1 text-info' />
                                </div>
                            </div>
                            {/* end::Symbol */}

                            {/* begin::Title */}
                            <div>
                                <div className='fs-4 text-dark fw-bold'>{dashboardValues?.zemanat.totalzemanat} عدد</div>
                                <div className='fs-7 text-muted fw-semibold'>کل درخواست</div>
                            </div>
                            {/* end::Title */}
                        </div>
                    </div>
                    {/* end::Col */}
                    {/* begin::Col */}
                    <div className='col'>
                        <div className='d-flex align-items-center me-2'>
                            {/* begin::Symbol */}
                            <div className='symbol symbol-50px me-3'>
                                <div className='symbol-label bg-light-danger'>
                                    <KTIcon iconName='abstract-26' className='fs-1 text-danger' />
                                </div>
                            </div>
                            {/* end::Symbol */}

                            {/* begin::Title */}
                            <div>
                                <div className='fs-4 text-dark fw-bold'>{dashboardValues?.zemanat.zemanatPending} عدد </div>
                                <div className='fs-7 text-muted fw-semibold'>در جریان</div>
                            </div>
                            {/* end::Title */}
                        </div>
                    </div>
                    {/* end::Col */}
                </div>
                {/* begin::Row */}
                <div className='row g-0 mt-5 mb-10'>
                    {/* begin::Col */}
                    <div className='col'>
                        <div className='d-flex align-items-center me-2'>
                            {/* begin::Symbol */}
                            <div className='symbol symbol-50px me-3'>
                                <div className='symbol-label bg-light-success'>
                                    <KTIcon iconName='basket' className='fs-1 text-success' />
                                </div>
                            </div>
                            {/* end::Symbol */}

                            {/* begin::Title */}
                            <div>
                                <div className='fs-4 text-dark fw-bold'>{dashboardValues?.zemanat.zemanatComplete} عدد</div>
                                <div className='fs-7 text-muted fw-semibold'>تکمیل شده</div>
                            </div>
                            {/* end::Title */}
                        </div>
                    </div>
                    {/* end::Col */}

                    {/* begin::Col */}
                    <div className='col'>
                        <div className='d-flex align-items-center me-2'>
                            {/* begin::Symbol */}
                            <div className='symbol symbol-50px me-3'>
                                <div className='symbol-label bg-light-primary'>
                                    <KTIcon iconName='cheque' className='fs-1 text-primary' />
                                </div>
                            </div>
                            {/* end::Symbol */}

                            {/* begin::Title */}
                            <div>
                                <div className='fs-4 text-dark fw-bold'>{dashboardValues?.zemanat.zemanatReject} عدد </div>
                                <div className='fs-7 text-muted fw-semibold'>عودت داده شده</div>
                            </div>
                            {/* end::Title */}
                        </div>
                    </div>
                    {/* end::Col */}
                </div>
                {/* end::Row */}

                <Mixed
                    className=''
                    chartColor='info'
                    chartHeight='200px'
                />
            </div>
            {/* end::Body */}
        </div>
    )
}


const chartOptions = (chartColor: string, chartHeight: string, value: number): ApexOptions => {
    const baseColor = getCSSVariableValue('--bs-' + chartColor)
    const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')
    const labelColor = getCSSVariableValue('--bs-gray-700')

    return {
        series: [value],
        chart: {
            fontFamily: 'inherit',
            height: chartHeight,
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 0,
                    size: '65%',
                },
                dataLabels: {
                    name: {
                        show: false,
                        fontWeight: '700',
                    },
                    value: {
                        color: labelColor,
                        fontSize: '30px',
                        fontWeight: '700',
                        offsetY: 12,
                        show: true,
                        formatter: function (val) {
                            return val + '%'
                        },
                    },
                },
                track: {
                    background: lightColor,
                    strokeWidth: '100%',
                },
            },
        },
        colors: [baseColor],
        stroke: {
            lineCap: 'round',
        },
        labels: ['Progress'],
    }
}



export { ZemanatBox }
